import { IpadCallback } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

const api = new RequestCreator<IpadCallback>('/ipad/ipad-callback');
export default api;
